module.exports = __webpack_public_path__ + "static/keynote@2x-b6d52aff5f614e0d9b3d64922fc70292.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/keynote@2x.jpg
// module id = 2655
// module chunks = 134932258599989